import { jsx as _jsx } from "react/jsx-runtime";
import { LAST_ACCOUNT_SLUG } from "constants/cookies";
import { getSlugDataInlineScript } from "/utils/inline-scripts";
import { isExistingNonPayingAccount } from "services/monday-platform/existing-accounts-service";
const platformDomain = process.env.PLATFORM_DOMAIN;
const RedirectToPlatfromScript = ({ persistantCookies })=>{
    const redirectToPlatformPricingIfNotPayingAccount = ()=>{
        if (isExistingNonPayingAccount(persistantCookies)) {
            // else we're not redirecting and not overriding appUrl
            return `
          const platformPricingUrl = "//"+lastActiveSlug + ".${platformDomain}/pricing_page";
          window.location.replace(platformPricingUrl);
      `;
        }
        return ` // do nothing - not in redirect variant `;
    };
    const redirectToPlatformIfNeeded = ()=>{
        return `
        ${getSlugDataInlineScript}
        const lastActiveSlug = cookieValueByName('${LAST_ACCOUNT_SLUG}');  // cookieValueByName defined inside getSlugDataInlineScript
 
        const preventRedirect = window.location.search.indexOf('no-redirect') > 0;

        if(lastActiveSlug && !preventRedirect) {
          var appUrl = "//"+lastActiveSlug + ".${platformDomain}";
          var path = window.location.pathname.trim();;

          const isPricingPage = path.includes("pricing");
          if (isPricingPage) {
            ${redirectToPlatformPricingIfNotPayingAccount()}
          }
          else {
            window.location.replace(appUrl);
          }
        }
    `;
    };
    return /*#__PURE__*/ _jsx("script", {
        dangerouslySetInnerHTML: {
            __html: redirectToPlatformIfNeeded()
        }
    });
};
export default RedirectToPlatfromScript;
